// extracted by mini-css-extract-plugin
export default {"instructions":"Instructions_instructions__D6uQJ","nav-style":"Instructions_nav-style__zUseG"};